import React from 'react';

import ImageWithSkeleton from '@commonTuna/react/components/UI/ImageWithSkeleton/ImageWithSkeleton';

import { GlobalPayer } from '@app/objects/GlobalPayer';

import '@app/scss/components/insurance.scss';

interface IProps {
	list: Array<GlobalPayer>;
}

const defaultCount = 8;

const Insurance: React.FC<IProps> = ({ list }) => {
	const [count, setCount] = React.useState<number>(defaultCount);

	const showMore = () => setCount(count + 8);

	const hide = () => setCount(defaultCount);

	return (
		<div className="insurance-container">
			<h5 style={{ width: '100%' }}><strong className="mr10">Insurances</strong></h5>
			{list.slice(0, count).map((value: GlobalPayer) => (
				<div key={value.id} className="insurance flex-row mb10">
					{(value.originalAvatar || value.avatar) ? <div className="insurance__avatar">
						<ImageWithSkeleton
							withLazy
							alt={value.name}
							title={value.name}
							src={`/remote/${value.originalAvatar ? value.originalAvatar : value.avatar || ''}`}
						/>
					</div>
						: <div className="insurance__avatar insurance__no-avatar">
							<i className="fa fa-medkit" title={value.name} />
						</div>
					}
				</div>
			))}
			<div className="insurance__buttons mt10">
				{count < list.length
					? <button type="button" className="btn load-more mr10" onClick={showMore}>
						View more
					</button> : null
				}
				{count > defaultCount
					? <button type="button" className="btn load-more" onClick={hide}>
						Hide
					</button> : null
				}
			</div>
		</div>
	);
};

export default Insurance;
